import * as React from "react";
import { useRouter } from "next/router";
import {
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IMnpPortoutTask } from "@nju/data-access-portal-service";
import { Panel, Separator, Text } from "@nju/ui";
import { Buttons } from "./Buttons";
import { getMobileServiceCTABannerConditions } from "./getMobileServiceCTABannerConditions";
import { getMobileStatusData } from "./getMobileStatusData";

interface IServiceCTABannerProps {
  portoutData: IMnpPortoutTask["properties"] | undefined;
  orchestrator: IMobileOrchestrator | IMultiOrderOrchestrator | undefined;
}

export function PortoutServiceCTABanner({
  portoutData,
  orchestrator,
}: IServiceCTABannerProps) {
  const { reload } = useRouter();

  const refresh = React.useCallback(() => {
    reload();
  }, [reload]);

  const conditions = React.useMemo(() => {
    return getMobileServiceCTABannerConditions({
      portoutData,
    });
  }, [portoutData]);

  const panelProps = React.useMemo(() => {
    return getMobileStatusData({
      conditions,
      portoutData,
    });
  }, [conditions, portoutData]);

  if (!panelProps) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const { text, title, iconName } = panelProps;

  return (
    <>
      <Panel iconName={iconName} title={title}>
        <Separator size="xs" tone="invisible" />
        <Text
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          {text}
        </Text>
        <Separator size="xs" tone="invisible" />
        <Buttons
          conditions={conditions}
          refreshCallback={refresh}
          userId={orchestrator?.userId}
        />
      </Panel>
      <Separator size="xs" tone="invisible" />
    </>
  );
}
